import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as WorkorderScheduleBydayActions from '../workorder-schedule-byday/workorder-schedule-byday.actions';
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  tap,
  throttleTime,
} from 'rxjs/operators';
import { from, Observable, of } from 'rxjs';
import {
  HideSpinner,
  ShowSpinner,
} from '../../../shared/spinner/spinner.action';
import { Action } from '@ngrx/store';
import * as ErrorActions from '../../error/error.actions';
import { ErrorType } from '../../error/model/error-type';
import { AlertMessageCommonService } from '../../../shared/alert-message-common/alert-message-common.service';
import { ServiceOrderService } from '../../backend/service-order/service-order.service';

type showSpinnerTypes = WorkorderScheduleBydayActions.WorkorderScheduleBydayGetRequest;

const showSpinnerActions = [
  WorkorderScheduleBydayActions.WORKORDER_SCHEDULE_BYDAY_GET_REQUEST,
];

type hideSpinnerTypes = WorkorderScheduleBydayActions.WorkorderScheduleBydayGetReceive;

const hideSpinnerActions = [
  WorkorderScheduleBydayActions.WORKORDER_SCHEDULE_BYDAY_GET_RECEIVE,
];

@Injectable()
export class WorkorderScheduleBydayEffects {
  constructor(
    private actions$: Actions,
    private serviceOrderService: ServiceOrderService,
    private alertMessageCommonService: AlertMessageCommonService
  ) {}

  @Effect()
  showSpinner: Observable<Action> = this.actions$.pipe(
    ofType<showSpinnerTypes>(...showSpinnerActions),
    map(() => new ShowSpinner())
  );

  @Effect()
  hideSpinner: Observable<Action> = this.actions$.pipe(
    ofType<hideSpinnerTypes>(...hideSpinnerActions),
    map(() => new HideSpinner())
  );

  @Effect()
  OnWorkorderScheduleBydayGetRequest$ = this.actions$.pipe(
    ofType<WorkorderScheduleBydayActions.WorkorderScheduleBydayGetRequest>(
      WorkorderScheduleBydayActions.WORKORDER_SCHEDULE_BYDAY_GET_REQUEST
    ),
    map((action) => action.payload),
    switchMap((payload) =>
      from(this.serviceOrderService.getWorkOrderSchedule(payload)).pipe(
        mergeMap((scheduledList) => [
          new WorkorderScheduleBydayActions.WorkorderScheduleBydayGetReceive({
            scheduleList: scheduledList,
            isScrolled: payload.isScrolled,
          }),
        ]),
        catchError((data) =>
          of(
            new ErrorActions.ErrorReceive({
              message: data.error.message,
              type: ErrorType.token,
              statusCode: data.status,
            })
          )
        )
      )
    )
  );
}
